module.exports = __webpack_public_path__ + "static/media/Teen_HoPro-mb-en.7dcb0a87.jpg";